var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactusDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8H6.66667H28",
    stroke: "#828282",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 8.00002V26.6667C25.3334 27.3739 25.0525 28.0522 24.5524 28.5523C24.0523 29.0524 23.374 29.3334 22.6667 29.3334H9.33341C8.62617 29.3334 7.94789 29.0524 7.4478 28.5523C6.9477 28.0522 6.66675 27.3739 6.66675 26.6667V8.00002M10.6667 8.00002V5.33335C10.6667 4.62611 10.9477 3.94783 11.4478 3.44774C11.9479 2.94764 12.6262 2.66669 13.3334 2.66669H18.6667C19.374 2.66669 20.0523 2.94764 20.5524 3.44774C21.0525 3.94783 21.3334 4.62611 21.3334 5.33335V8.00002",
    stroke: "#828282",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14.6667V22.6667",
    stroke: "#828282",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 14.6667V22.6667",
    stroke: "#828282",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactusDeleteIcon);
export default __webpack_public_path__ + "static/media/contactus_delete_icon.172cb1477d89475fe1e7247f7f879386.svg";
export { ForwardRef as ReactComponent };